export const ERROR_NO_EMAIL         = 'Please enter an email address.';
export const ERROR_INVALID_EMAIL    = 'Please enter a valid email address.'
export const ERROR_NO_POSTCODE      = 'Please enter a postcode.';
export const ERROR_INVALID_POSTCODE = 'Please enter a valid postcode.';
export const ERROR_NO_PASSWORD      = 'Please enter a password';

